<template>
  <div class="section mt-5" style="position: relative; padding: 80px 0; width: 50%; margin: 0 auto;">
    <img src="@/assets/seguridad_fondo.jpg" class="img-fluid" style="position: absolute; top: 0; left: 50%; transform: translateX(-50%); width: 100%; height: 100%; object-fit: cover; opacity: 0.6;"  alt="Imagen de misión">
    <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.7); z-index: 1;"></div>
    <div class="container text-center" style="position: relative; z-index: 2;">
      <div class="row justify-content-md-center">
        <div class="col-md-12 col-lg-12">
          <h2 style="font-weight: 900; text-decoration: underline; color: white;">POLÍTICA DE SEGURIDAD</h2>
          <p class="category" style="color: white;">Nuestro objetivo es y siempre será el bienestar de nuestros colaboradores velando por su integridad física, social y emocional, dotándolos de los equipos y herramientas necesarias para el correcto desempeño de sus funciones y actividades, poniendo siempre en primer lugar su salud e integridad física.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>



<script>

export default {
  components: {
  }
};
</script>
<style>
.tab-content.tab-content-padding {
  padding: 20px;
}
@media (max-width: 767px) {
  .section {
    width: 100% !important;
  }
}
</style>
